<template>
  <div>
    <div class="radio-container">
      <div v-for="(option, index) in options" :key="index" class="radio-item">
        <input
          type="radio"
          :id="option.value"
          :value="option.value"
          v-model="internalValue"
          @change="$emit('input', internalValue)"
          :class="{ 'error-border': error }"
        />
        <label :for="option.value">{{ option.label }}</label>
      </div>
    </div>
    <span class="error" v-if="error">
      <img src="@/assets/img/1x/error_icon.png" alt="error" />
      <p>{{ error }}</p>
    </span>
  </div>
</template>

<script>
export default {
  name: "CheckBoxPlacePay",
  props: {
    options: {
      type: Array,
      default: () => []
    },
    value: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      internalValue: this.value
    };
  },
  watch: {
    value(newVal) {
      this.internalValue = newVal;
    }
  }
};
</script>

<style scoped>
span.error {
  margin-left: 16px;
  margin-top: 8px;
  display: block;
}

span > img,
span > p {
  display: inline-block;
  vertical-align: top;
}

span > p {
  margin-left: 2px;
  margin-top: 0px;
  margin-bottom: 0px;
  font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
  font-size: 12px;
  line-height: 1.33;
  color: #121212;
}

.radio-container {
  display: flex;
  flex-direction: row;
  gap: 2rem; /* Espacio entre cada bloque de radio y texto */
  font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
}

.radio-item {
  display: flex;
  align-items: center;
  justify-content: 2px;
  width: 80%;
  margin-right: 20px;
}

input[type="radio"] {
  -webkit-appearance: none;
  appearance: none;
  width: 30px;
  height: 30px;
  border: 1.5px solid #566573;
  border-radius: 50%;
  outline: none;
  position: relative;
  margin-right: 5px;
}

input[type="radio"]:checked::after {
  content: "";
  position: absolute;
  width: 15px;
  height: 15px;
  background-color: #004481;
  border-radius: 50%;
  top: 6px;
  left: 6px;
}

/* Clase para el borde rojo en caso de error */
input[type="radio"].error-border {
  border: 2px solid #b92a45;
}

@media screen and (max-width: 600px) {
  .radio-container {
    flex-direction: column;
    gap: 1rem;
  }

  .radio-item {
    width: 100%;
    margin-right: 0;
  }
}
</style>
